import { useQuery } from 'react-query';
import api from '../services/api';

export interface DashDevice {
  device_id: string;
  device_name: string;
  platform: string;
  last_seen?: string;
  created_at?: string;
  status?: 'active' | 'paused' | 'revoked';
  site_id?: string | null;
  /** Mobile/Roaming: the device travels between sites, so it belongs to none.
   *  Mutually exclusive with site_id — the server clears one when you set the
   *  other. */
  is_roaming?: number | boolean;
  display_name?: string | null;
  ip_address?: string | null;
  vpn_ip?: string | null;
}

export interface Site {
  id: string;
  name: string;
}

export interface UserInfoResponse {
  user_id: string;
  email: string;
  name?: string | null;
  phone?: string | null;
  created_at?: string | null;
  has_password?: boolean;
  devices: DashDevice[];
  sites?: Site[];
}

// Full account info (used by the dashboard for the device list). Separate from
// AuthContext, which only tracks the signed-in identity.
export const useUserInfo = () =>
  useQuery<UserInfoResponse>(
    'user-info',
    async () => {
      const res = await api.get<UserInfoResponse>('/api/user/info');
      return res.data;
    },
    { retry: 1, refetchInterval: 60000 },
  );
